import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { getSessionByKey, GetUserFullName } from 'helpers';
import atoms from 'ctsutheme/components/atoms';
import { RenderElement } from 'components/RenderHelpers';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { openModal } from 'actions/common';
import { TE } from 'appconstants';
import { FasPlus, FasSyncAlt } from 'assets/icons';
import { ProtocolBrowserColumns } from '../gridcolumns';

const { Button } = atoms;

const BrowserInfo = ({
  getToken,
  syncPermission,
  handleSyncBtnClick,
  handleunRegisteredStudyBtnClick
}) => (
  <GridTable
    tag={`${TE.ID}protocolbrowser${TE.TABLE}`}
    renderTitle={() => (
      <span role="heading" aria-level="1" className="content-page-title font-title color-blue font-bold">Protocol Browser</span>
    )}
    exportTitle="Protocol Browser"
    user={GetUserFullName()}
    remoteUrl={`protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/browse`}
    getToken={getToken}
    columns={ProtocolBrowserColumns}
    enableToolbar
    showFilterByDefault
    sortable
    filterable
    recordPerPage={25}
    defaultSorts={[{
      field: 'protocolNumber',
      dir: 'asc'
    }]}
    toPdf={false}
    renderCustomHeaderIcons={
      () => (
        <RenderElement access={syncPermission}>
          <Button
            variant="outlined"
            color="primary"
            data-id="synchronizeProtocol"
            name="synchronizeProtocol"
            onClick={() => handleSyncBtnClick()}
            className="turquoise"
          >
            <FasSyncAlt className="mr-1" />
            Protocol Sync
          </Button>
          &nbsp;
          <Button
            variant="outlined"
            color="primary"
            title="Create Unregistered Study"
            data-id="unregisteredStudy"
            name="unregisteredStudy"
            onClick={() => handleunRegisteredStudyBtnClick()}
            className="turquoise"
          >
           <FasPlus className="ml-n1" /> 
          <span className="ml-1">Unregistered Study</span>
          </Button>
        </RenderElement>
      )
    }
  />
);

const withConnectState = connect(
  (state, ownProps) => ({
  }),
  dispatch => bindActionCreators(
    {
      onOpenModal: openModal
    },
    dispatch
  )
);

const ProtocolBrowserInfo = compose(
  withConnectState,
  withHandlers({
    handleSyncBtnClick: props => event => {
      const { onOpenModal } = props;
      onOpenModal({
        type: 'SyncProtocol',
        title: 'Synchronize Protocol',
        modalSize: 'md',
        data: null        
      });
    },
    handleunRegisteredStudyBtnClick: props => event => {
      const { onOpenModal } = props;
      onOpenModal({
        type: 'UnregisteredStudy',
        title: 'Create Unregistered Study',
        data: null       
      });
    }
  })
)(BrowserInfo);

export default ProtocolBrowserInfo;
